import * as React from "react"

import {
  footerStyle,
  copyright
} from "./footer.module.css"

export function Footer() {
  return (
    <footer className={footerStyle}>
      <div className={copyright}>
        Copyright &copy; 2002-{new Date().getFullYear()} · All rights reserved · Independent Forensics · Shopify Headless Store
      </div>
    </footer>
  )
}
